export default class NewsfeedApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getPages(params, httpConfig) {
    return this.httpGet('channels', params, httpConfig);
  }

  getPage(id, params, httpConfig) {
    return this.httpGet(`channels/${id}`, params, httpConfig);
  }

  createPage(page, params, httpConfig) {
    return this.httpPost('channels', page, params, httpConfig);
  }

  deletePage(id, params, httpConfig) {
    return this.httpDelete(`channels/${id}`, params, httpConfig);
  }

  editPage(page, params, httpConfig) {
    return this.httpPut(`channels/${page.id}`, page, params, httpConfig);
  }

  markNewsfeedNotificationsAsRead(params, httpConfig) {
    return this.httpPut('/channels/notifications', params, httpConfig);
  }

  getArticles(channelId, params, httpConfig) {
    return this.httpGet(`/channels/${channelId}/articles`, params, httpConfig);
  }

  createArticle(channelId, article, params, httpConfig) {
    return this.httpPost(`/channels/${channelId}/articles`, article, params, httpConfig);
  }

  deleteArticle(channelId, articleId, params, httpConfig) {
    return this.httpDelete(`/channels/${channelId}/articles/${articleId}`, params, httpConfig);
  }

  getArticle(channelId, articleId, params, httpConfig) {
    return this.httpGet(`/channels/${channelId}/articles/${articleId}`, params, httpConfig);
  }

  editArticle(channelId, article, params, httpConfig) {
    return this.httpPut(
      `/channels/${channelId}/articles/${article.id}`,
      article,
      params,
      httpConfig
    );
  }

  getArticleComments(channelId, articleId, params, httpConfig) {
    return this.httpGet(
      `/channels/${channelId}/articles/${articleId}/comments`,
      params,
      httpConfig
    );
  }

  createArticleComment(channelId, articleId, comment, params, httpConfig) {
    return this.httpPost(
      `/channels/${channelId}/articles/${articleId}/comments`,
      comment,
      params,
      httpConfig
    );
  }

  editArticleComment(channelId, articleId, comment, params, httpConfig) {
    return this.httpPut(
      `/channels/${channelId}/articles/${articleId}/comments/${comment.id}`,
      comment,
      params,
      httpConfig
    );
  }

  deleteArticleComment(channelId, articleId, commentId, params, httpConfig) {
    return this.httpDelete(
      `/channels/${channelId}/articles/${articleId}/comments/${commentId}`,
      params,
      httpConfig
    );
  }

  getArticleComment(channelId, articleId, commentId, params, httpConfig) {
    return this.httpGet(
      `/channels/${channelId}/articles/${articleId}/comments/${commentId}`,
      params,
      httpConfig
    );
  }

  getArticleCommentLikes(channelId, articleId, commentId, params, httpConfig) {
    return this.httpGet(
      `/channels/${channelId}/articles/${articleId}/comments/${commentId}/likes`,
      params,
      httpConfig
    );
  }

  unlikeArticleComment(channelId, articleId, commentId, params, httpConfig) {
    return this.httpDelete(
      `/channels/${channelId}/articles/${articleId}/comments/${commentId}/likes`,
      params,
      httpConfig
    );
  }

  likeArticleComment(channelId, articleId, commentId, params, httpConfig) {
    return this.httpPost(
      `/channels/${channelId}/articles/${articleId}/comments/${commentId}/likes`,
      params,
      httpConfig
    );
  }

  getArticleLikes(channelId, articleId, params, httpConfig) {
    return this.httpGet(`/channels/${channelId}/articles/${articleId}/likes`, params, httpConfig);
  }

  unlikeArticle(channelId, articleId, params, httpConfig) {
    return this.httpDelete(
      `/channels/${channelId}/articles/${articleId}/likes`,
      params,
      httpConfig
    );
  }

  likeArticle(channelId, articleId, params, httpConfig) {
    return this.httpPost(`/channels/${channelId}/articles/${articleId}/likes`, params, httpConfig);
  }

  moveArticle(channelId, articleId, body, params, httpConfig) {
    return this.httpPost(
      `/channels/${channelId}/articles/${articleId}/move`,
      body,
      params,
      httpConfig
    );
  }

  getSeenList(channelId, articleId, params, httpConfig) {
    return this.httpGet(`/channels/${channelId}/articles/${articleId}/seen`, params, httpConfig);
  }

  markArticleAsRead(channelId, articleId, params, httpConfig) {
    return this.httpPut(`/channels/${channelId}/articles/${articleId}/seen`, params, httpConfig);
  }

  markPageAsRead(channelId, params, httpConfig) {
    return this.httpPut(`/channels/${channelId}/read`, params, httpConfig);
  }

  getPageSubscribers(channelId, params, httpConfig) {
    return this.httpGet(`/channels/${channelId}/subscribers`, params, httpConfig);
  }

  subscribeToPage(channelId, params, httpConfig) {
    return this.httpPost(`/channels/${channelId}/subscribers`, params, httpConfig);
  }

  unsubscribeFromPage(channelId, params, httpConfig) {
    return this.httpDelete(`/channels/${channelId}/subscribers`, params, httpConfig);
  }
}
